<div class="staticcontainer">
    <div class="scrollcontainer">
        <div class="container">
            <div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{label1}}</mat-label>
                    <input matInput type="number" step="1" min="1" class="text-right" [ngModel]="box?.length"
                        (ngModelChange)="box.length = $event" (focusout)="checkForComponentChanges()"
                        [disabled]="editableComponents?.length == 0 || lengthDisabled" autocomplete="off"
                        (keypress)="integerOnly($event)">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{label2}}</mat-label>
                    <input matInput type="number" step="1" min="1" class="text-right" [ngModel]="box?.width"
                        (ngModelChange)="box.width = $event" (focusout)="checkForComponentChanges()"
                        [disabled]="editableComponents?.length == 0" autocomplete="off"
                        (keypress)="integerOnly($event)">
                </mat-form-field>
            </div>
            <div *ngIf="showToolboxName">
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{label3}}</mat-label>
                    <input matInput class="text-right" [ngModel]="name" (ngModelChange)="name = $event"
                        (focusout)="checkForComponentChanges()" [disabled]="editableComponents?.length == 0"
                        autocomplete="off">
                </mat-form-field>
            </div>
            <div *ngIf="uid != undefined && uid != null">
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{label4}}</mat-label>
                    <input matInput class="text-right" [ngModel]="uid" (ngModelChange)="uid = $event"
                        (focusout)="checkForComponentChanges()" [disabled]="editableComponents?.length == 0"
                        autocomplete="off">
                </mat-form-field>
            </div>
        </div>

        <div class="container">
            <hr>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label5}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="posX"
                    (ngModelChange)="posX = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label6}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="posY"
                    (ngModelChange)="posY = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
        </div>
        <div class="container" *ngIf="!marginInputDisabled">
            <hr>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label7}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="marginTop"
                    (ngModelChange)="marginTop = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label8}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="marginBottom"
                    (ngModelChange)="marginBottom = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label9}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="marginLeft"
                    (ngModelChange)="marginLeft = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{label10}}</mat-label>
                <input matInput class="text-right" type="number" step="1" [ngModel]="marginRight"
                    (ngModelChange)="marginRight = $event" (focusout)="checkForComponentChanges()"
                    [disabled]="editableComponents?.length == 0" autocomplete="off"
                    (keypress)="integerOnlyWithNegatives($event)">
            </mat-form-field>
        </div>
    </div>
    <div class="container">
        <button mat-raised-button class="fullwidth color" (click)="openAdvancedProperties()"
            [disabled]="viewComponent == null || !enableAdvancedProperties">{{action1}}</button>
    </div>
</div>